import responsive from "../../assets/features/desktop/responsive.svg";
import nolimit from "../../assets/features/desktop/no-limit.svg";
import embed from "../../assets/features/desktop/embed.svg";

import domain from "../../assets/features/desktop/custom-domain.svg";
import boost from "../../assets/features/desktop/boost-exposure.svg";
import drag from "../../assets/features/desktop/drag-drop.svg";

export const FeaturesData = [
	{
		src: responsive,
		title: "100% Responsive",
		para:
			"No matter which the device you’re on, our site is fully responsive and stories look beautiful on any screen.",
	},
	{
		src: nolimit,
		title: "No Photo Upload Limit",
		para:
			"Our tool has no limits on uploads or bandwidth. Freely upload in bulk and share all of your stories in one go.",
	},
	{
		src: embed,
		title: "Available to Embed",
		para:
			"Embed Tweets, Facebook posts, Instagram media, Vimeo or YouTube videos, Google Maps, and more.",
	},
	{
		src: domain,
		title: "Custom Domain",
		para:
			"With Photosnap subscriptions you can host your stories on your own domain. You can also remove our branding!",
	},
	{
		src: boost,
		title: "Boost Your Exposure",
		para:
			"Users that viewed your story or gallery can easily get notifed of new and featured stories with our built in mailing list.",
	},
	{
		src: drag,
		title: "Drag & Drop Image",
		para:
			"Easily drag and drop your image and get beautiful shots everytime. No over the top tooling to add friction to creating stories.",
	},
];

export const FeatureData = [
	{
		src: responsive,
		title: "100% Responsive",
		para:
			"No matter which the device you’re on, our site is fully responsive and stories look beautiful on any screen.",
	},
	{
		src: nolimit,
		title: "No Photo Upload Limit",
		para:
			"Our tool has no limits on uploads or bandwidth. Freely upload in bulk and share all of your stories in one go.",
	},
	{
		src: embed,
		title: "Available to Embed",
		para:
			"Embed Tweets, Facebook posts, Instagram media, Vimeo or YouTube videos, Google Maps, and more.",
	},
];
